import React from 'react'

import styled from 'styled-components'
import {
  accessibilityColors,
  mainTextColor,
  premiumBg,
  white,
} from '@edulastic/colors'
import { IconStar, IconStarBlack } from '@edulastic/icons'
import { withRouter } from 'react-router-dom'
import { Popover } from 'antd'
import {
  EduButton,
  EduElse,
  EduIf,
  EduThen,
  FlexContainer,
} from '@edulastic/common'
import { navigationState } from '../../../src/constants/navigation'
import { onEnterKeyPressHandler } from '../../../../common/utils/helpers'

const AddOnTag = ({ history, margin, message, component, isWithAiButton }) => {
  const goToAddOnsPage = () => {
    history.push({
      pathname: '/author/subscription',
      state: { view: navigationState.SUBSCRIPTION.view.ADDON },
    })
  }

  const hoverContent = (
    <FlexContainer
      flexDirection="column"
      role="tooltip"
      id="ai-addon-popover-desc"
    >
      <DollarSymbolWrapperWithText>
        <IconStar /> <AddOnTextWrapper>ADD-ON</AddOnTextWrapper>
      </DollarSymbolWrapperWithText>
      <AddonLabel>{message}</AddonLabel>
    </FlexContainer>
  )

  return (
    <EduIf condition={!component}>
      <EduThen>
        <Popover
          placement="top"
          trigger={['hover', 'focus']}
          content={hoverContent}
        >
          {isWithAiButton ? (
            <StyledButton
              onClick={goToAddOnsPage}
              onKeyDown={(e) => onEnterKeyPressHandler(e, goToAddOnsPage)}
              tabIndex={0}
              aria-describedby="ai-addon-popover-desc"
              aria-label="Buy VideoQuiz and AI Suite Add-on"
            >
              <IconStarBlack />
            </StyledButton>
          ) : (
            <StyledLink
              margin={margin}
              onClick={goToAddOnsPage}
              onKeyDown={(e) => onEnterKeyPressHandler(e, goToAddOnsPage)}
              tabIndex={0}
              aria-describedby="ai-addon-popover-desc"
              aria-label="Buy VideoQuiz and AI Suite Add-on"
            >
              <DollarSymbolWrapper>
                <IconStar />
              </DollarSymbolWrapper>
            </StyledLink>
          )}
        </Popover>
      </EduThen>
      <EduElse>
        <Popover
          placement="top"
          trigger={['hover', 'focus']}
          content={hoverContent}
        >
          <span>{component}</span>
        </Popover>
      </EduElse>
    </EduIf>
  )
}

export default withRouter(AddOnTag)

export const DollarSymbolWrapper = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${white};
  margin-right: 1rem;
  width: 22px;
  text-align: center;
  border-radius: 2px;
`
const DollarSymbolWrapperWithText = styled(DollarSymbolWrapper)`
  background: ${premiumBg};
  padding-left: 5px;
  width: max-content;
`
const Link = styled.a`
  position: relative;
  margin: ${({ margin }) => margin};
  &:focus {
    outline: 2px solid ${accessibilityColors.theme.white};
  }
`
const AddOnTextWrapper = styled.p`
  font-weight: bolder;
  font-size: 11px;
  padding-right: 1rem;
`
const AddonLabel = styled.p`
  color: ${mainTextColor};
  margin-top: 5px;
  font-size: 11px;
`

const StyledLink = styled(Link)`
  &:focus {
    outline: 2px solid ${accessibilityColors.theme.blueHover};
  }
`

const StyledButton = styled(EduButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  &.ant-btn.ant-btn-primary {
    height: 36px;
    width: 32px;
    border: none;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    background-color: ${premiumBg};
    margin: 0px;
    &:focus {
      outline: 2px solid ${accessibilityColors.theme.black};
    }
  }
  &:hover,
  &:focus,
  &:active {
    &.ant-btn.ant-btn-primary {
      background: transparent;
      border: none;
      background-color: ${premiumBg};
    }
  }
`
